var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C10.1843304,0 10.7391304,0.554783478 10.7391304,1.23913043 L10.7391304,8.26086957 L17.7608696,8.26086957 C18.4452,8.26086957 19,8.81566957 19,9.5 C19,10.1843304 18.4452,10.7391304 17.7608696,10.7391304 L10.7391304,10.7391304 L10.7391304,17.7608696 C10.7391304,18.4452 10.1843304,19 9.5,19 C8.81566957,19 8.26086957,18.4452 8.26086957,17.7608696 L8.26086957,10.7391304 L1.23913043,10.7391304 C0.554783478,10.7391304 0,10.1843304 0,9.5 C0,8.81566957 0.554783478,8.26086957 1.23913043,8.26086957 L8.26086957,8.26086957 L8.26086957,1.23913043 C8.26086957,0.554783478 8.81566957,0 9.5,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19,0 19,19 0,19 0,0",
    stroke: "none",
    fill: "#FF7700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.7391304,1.23913043 C10.7391304,0.554783478 10.1843304,0 9.5,0 C8.81566957,0 8.26086957,0.554783478 8.26086957,1.23913043 L8.26086957,8.26086957 L1.23913043,8.26086957 C0.554783478,8.26086957 0,8.81566957 0,9.5 C0,10.1843304 0.554783478,10.7391304 1.23913043,10.7391304 L8.26086957,10.7391304 L8.26086957,17.7608696 C8.26086957,18.4452 8.81566957,19 9.5,19 C10.1843304,19 10.7391304,18.4452 10.7391304,17.7608696 L10.7391304,10.7391304 L17.7608696,10.7391304 C18.4452,10.7391304 19,10.1843304 19,9.5 C19,8.81566957 18.4452,8.26086957 17.7608696,8.26086957 L10.7391304,8.26086957 L10.7391304,1.23913043 Z",
    stroke: "#FF7700",
    strokeWidth: 1,
    fill: "none",
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5ea31158515433c33be1eb1f8af7a867.svg";
export { ForwardRef as ReactComponent };